'use strict';

(function ($) {

  var shrinkHeader = 100;
  // var didScroll;
  // var lastScrollTop = 0;
  // var delta = 5;
  // var navbarHeight = $('#shopify-section-header').outerHeight();

  var wow = new WOW({
    mobile: true,
    live: true // default
  });
  wow.init();

  $(document).ready(function () {

    $('.bringToggle').click(function () {
      console.log('oui');
    });

    $('select').not('.no-style').niceSelect();

    $('.js-mobile-nav-toggle').on('click', function (event) {

      $('#shopify-section-header').toggleClass('menu-active');
      $('.mobile-nav-wrapper').toggleClass('is-active');
      $('.mobile-nav-wrapper').css('top', $('header').height());

      // if($('.js-mobile-nav-toggle').hasClass('is-active')) {
      //     $('html').addClass('no-scroll');
      // } else {
      //     $('html').removeClass('no-scroll');
      // }
      return false;
    });

    //FOCUS EFFECT
    $(".form-wrapper form input, .form-wrapper form textarea").focus(function () {
      $(this).parent().addClass('focus');
    }).blur(function () {
      if (!$(this).val()) {
        $(this).parent().removeClass('focus');
      }
    });

    $('.form-wrapper form').filter(':input[type=text], :input[type=password], textarea').each(function () {

      if ($.trim($(this).val()) != '') {
        $(this).parent().addClass('focus');
      };
    });
  });

  $(window).scroll(function (event) {
    var scroll = getCurrentScroll();

    if (scroll >= shrinkHeader) {
      $('#shopify-section-header').addClass('shrink');
      $('.cart-popup-wrapper').addClass('shrink');
    } else {
      $('#shopify-section-header').removeClass('shrink');
      $('.cart-popup-wrapper').removeClass('shrink');
    }

    // didScroll = true;
  });

  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  // setInterval(function() {
  //   if (didScroll) {
  //     hasScrolled();
  //     didScroll = false;
  //   }
  // }, 250);
  //
  // function hasScrolled() {
  //   var st = $(window).scrollTop();
  //
  //   // Make sure they scroll more than delta
  //   if (Math.abs(lastScrollTop - st) <= delta)
  //       return;
  //
  //   // If they scrolled down and are past the navbar, add class .nav-up.
  //   // This is necessary so you never see what is "behind" the navbar.
  //   if (st > lastScrollTop && st > navbarHeight){
  //       // Scroll Down
  //       $('#shopify-section-header').removeClass('nav-down').addClass('nav-up');
  //   } else {
  //       // Scroll Up
  //       if(st + $(window).height() < $(document).height()) {
  //           $('#shopify-section-header').removeClass('nav-up').addClass('nav-down');
  //       }
  //   }
  //
  //   lastScrollTop = st;
  // }
})(jQuery);